import { useForm, useWatch } from "react-hook-form";
import { useAuthStore } from "../../store/authStore"
import FormInputText from "../shared/FormInputText";
import { zodResolver } from "@hookform/resolvers/zod";
import { schemaUtils } from "@centivo-business/utils";

import * as z from "zod/v4";
import { sendToken } from "../../utils/apiUtils";
import VerifyToken from "./VerifyToken";
import { useState } from "react";
import { ALLOWED_DOMAINS } from "../../utils/constants";

const Login = () => {
    const { isAuthenticated, logIn } = useAuthStore()
    const [errorMessage, setErrorMessage] = useState()
    const [ttl, setTtl] = useState()

    const {
        control,
        register,
        formState: { errors, isValid, isDirty, dirtyFields, isSubmitting, isSubmitSuccessful },
        getValues,
        handleSubmit,
    } = useForm({
        resolver: zodResolver(
            z.object({
                email: z.email(
                    //     {
                    //     error: (issue) => {
                    //         console.log(issue)
                    //         return 'Invalid Email'
                    //     }
                    // }
                )
                    .refine(
                        (email) => {
                            const domain = email.split("@")[1]?.toLowerCase();
                            return ALLOWED_DOMAINS.includes(domain);
                        },
                        { error: (issue) => 'Domain not allowed' }
                    )
            })
        ),
        // defaultValues: {
        //     email: ''
        // },
        mode: "onSubmit"
    });

    // const values = useWatch({ control })
    const onSubmit = async (values) => {
        setErrorMessage()

        try {
            const res = await sendToken({ ...values, hostname: window.location.hostname })
            setTtl(res.ttl)

        } catch (err) {
            setErrorMessage(err.message)
        }


    }
    //    logIn()
    // const onError = (err) => {
    //     console.log({ err })
    //     setErrorMessage(err.message)
    // }
    // console.log(errors['email'])
    // console.log({ errors, isValid, isDirty: Object.keys(dirtyFields).length })

    if (ttl) {
        return <VerifyToken email={getValues('email')} ttl={ttl} />
    }

    return (
        <div style={{ display: 'grid', placeItems: 'center', height: '80%' }}>


            <div style={{ width: '100%', maxWidth: '500px', padding: '1rem' }}>
                <div style={{ textAlign: 'center', padding: '0rem 0rem 3rem 0rem' }}>
                    <img
                        //src={centivoLog} 
                        src={"https://centivo.com/wp-content/themes/studio-simpatico/svgs/logo.svg"}
                        //        src="https://centivo.com/wp-content/themes/studio-simpatico/svgs/logo-c.svg"
                        alt="centivo-logo"
                    // width={180}
                    />
                </div>


                <div>
                    <p className="title">Log In</p>
                    <p className="sub-title">Sign in with your Centivo email</p>



                    <form onSubmit={handleSubmit(onSubmit)} className="form" style={{ paddingTop: '3rem' }}>
                        <FormInputText label={'Email'} name="email" type="email" register={register} errors={errors} placeholder="Email" />
                        {errorMessage && <p className="danger" style={{ padding: '0rem 0rem 2rem 0rem' }}>{errorMessage}</p>}

                        {isSubmitting ? <div className="loader" /> : <input
                            className="btn"
                            type="submit"
                            disabled={Object.keys(dirtyFields).length && !isValid}
                            value={'Continue'} />}


                    </form>


                </div>

            </div>

        </div >
    )
}

export default Login